
import Modify from 'ol/interaction/Modify';

function createInteractionModifyFeature(options) {

    let modify = new Modify({
        source: options.tempLayer.getSource()
    });

    modify.set('mapToolId', 'ModifyFeature');
    modify.setActive(false);

    modify.on('modifyend', (e) => {
        if (options.onMapToolExecute) {
            if (e.features.getLength() > 0) {
                options.onMapToolExecute(
                    modify.get('mapToolId'),
                    {
                        feature: e.features.item(0)
                    }
                );
            }
        }
    });

    return modify;
}

export default createInteractionModifyFeature;
